import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadUser: -1,
  },
  users: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;
  switch (type) {
    case ACTION_TYPES.USER_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadUser: 0,
        },
      };
    case ACTION_TYPES.USER_GET_SUCCEED: {
      return {
        ...state,
        status: {
          ...state.status,
          loadUser: 1,
        },
        users: {
          ...state.users,
          [payload.data.userUuid]: payload.data,
        },
      };
    }
    case ACTION_TYPES.USER_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadUser: 2,
        },
        error,
      };
    default:
      return state;
  }
}
